// Broadcast a `postMessage` payload to every ancestor frame (immediate
// parent, top, and any frames in between), each wrapped in try/catch so
// cross-origin walks can't break the caller. All payloads are namespaced
// with `source: "powtoon-live-avatar"` so hosts can filter safely.
export function postToAncestors(payload: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  const message = { source: "powtoon-live-avatar", ...payload };
  const seen = new Set<Window>();
  const send = (target: Window | null | undefined) => {
    if (!target || target === window || seen.has(target)) return;
    seen.add(target);
    try {
      target.postMessage(message, "*");
    } catch {
      /* ignore cross-origin / detached frame errors */
    }
  };
  // Walk up from window.parent to window.top, posting to each distinct frame.
  try {
    let cur: Window | null = window.parent;
    let hops = 0;
    while (cur && cur !== window && hops++ < 20) {
      send(cur);
      const next: Window | null = cur.parent;
      if (!next || next === cur) break;
      cur = next;
    }
  } catch {
    /* ignore */
  }
  // Always also target window.top in case the walk was blocked.
  try {
    send(window.top);
  } catch {
    /* ignore */
  }
}